/**
 * Expose all endponts for 'auth'.
 */
const AuthApi = api => {
  return {
    signin: (username, password) =>
      api.post("authenticate", { username, password }),
    refreshToken: (token, refreshToken) =>
      api.post(`token-refresh`, {
        id_token: token,
        refresh_token: refreshToken
      })
  };
};

export default AuthApi;



// WEBPACK FOOTER //
// ./src/services/api/AuthApi.js